/* SEKO : fiche produit, bloc "Options cadeau".
   Les boutons - et + reglent la quantite de vrais produits (sac, rubans) dans le panier Shopify.
   Le formulaire de commande les reprend ensuite avec le reste du panier. */
(function () {
  var root = document.querySelector('[data-seko-cadeau]');
  if (!root) return;
  var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var lignes = root.querySelectorAll('[data-variant]');

  function maj(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < lignes.length; i++) {
      var l = lignes[i];
      var id = parseInt(l.getAttribute('data-variant'), 10);
      var q = 0;
      for (var j = 0; j < items.length; j++) {
        if (items[j].variant_id === id || items[j].id === id) { q += items[j].quantity; }
      }
      l.querySelector('output').textContent = String(q);
      l.querySelector('[data-moins]').disabled = q <= 0;
      if (q > 0) { root.open = true; }
    }
  }

  function lire() {
    return fetch(base + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(maj)
      .catch(function () {});
  }

  function regler(id, q) {
    var updates = {};
    updates[id] = q;
    root.classList.add('seko-cadeau--charge');
    return fetch(base + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        maj(cart);
        try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
      })
      .catch(lire)
      .then(function () { root.classList.remove('seko-cadeau--charge'); });
  }

  root.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('button') : null;
    if (!b) return;
    var l = b.closest('[data-variant]');
    if (!l) return;
    var q = parseInt(l.querySelector('output').textContent, 10) || 0;
    if (b.hasAttribute('data-plus')) { q = Math.min(q + 1, 20); } else { q = Math.max(q - 1, 0); }
    regler(l.getAttribute('data-variant'), q);
  });

  lire();
})();
